import { render, staticRenderFns } from "./shopnavManage.vue?vue&type=template&id=95b70c14&scoped=true"
import script from "./shopnavManage.vue?vue&type=script&lang=js"
export * from "./shopnavManage.vue?vue&type=script&lang=js"
import style0 from "./shopnavManage.vue?vue&type=style&index=0&id=95b70c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b70c14",
  null
  
)

component.options.__file = "shopnavManage.vue"
export default component.exports